import React from 'react';
import { connect } from 'react-redux';

import { Field, formValueSelector } from 'redux-form';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import RadioField from '../fields/RadioField';
import Heading from '../elements/PageHeading';
import renderError from '../elements/renderError';
import { WIZARD_FORM_NAME } from '../../constants/common';

const Form = styled.div`
  margin-top: 50px;
  text-align: center;
  margin-bottom: 30px;
`;

const ReprovisionModePage = ({ handleSubmit, t, type }) => (
  <React.Fragment>
    <Heading text={t('reprovision_mode.title')} />
    <Form onSubmit={handleSubmit}>
      <fieldset>
        {type !== 'selflyEncode' &&
          ['1', '2', '3'].map(reproType => (
            <RadioField
              key={reproType}
              name="ReprovisionMode"
              type="radio"
              component="input"
              value={reproType}
              label={t(`reprovision_mode.${reproType}`)}
            />
          ))}
        {type === 'selflyEncode' &&
          ['1', '2'].map(reproType => (
            <RadioField
              key={reproType}
              name="ReprovisionMode"
              type="radio"
              component="input"
              value={reproType}
              label={t(`reprovision_mode.${reproType}`)}
            />
          ))}
        <Field name="ReprovisionMode" component={renderError} />
      </fieldset>
    </Form>
  </React.Fragment>
);

const selector = formValueSelector(WIZARD_FORM_NAME);
const mapStateToProps = state => ({
  type: selector(state, 'Type'),
});

export default translate()(connect(mapStateToProps)(ReprovisionModePage));
